import React from 'react';
import withTheme from '../../common/withTheme';

const MerchantHeader = () => {

    return (
        <div className="merchant-header"></div>
    )
}
export default withTheme(MerchantHeader);